import { useLang } from "../contexts/LanguageContext";
import { useAuth } from "../contexts/AuthContext";

import NavbarIndex from '../components/NavbarIndex';
import FaqAccordion from '../components/Index/FaqAccordion';
import Devices from '../components/Index/Devices';

import { Container } from "react-bootstrap";
import Footer from "../components/Footer";



export default function Index() {

  /* Inciar constante de traducción */
  const { t } = useLang();
  /* Variables del Usuario */
  const { user } = useAuth();

  let displayName = "";
  if (user) {
    const nameSource = user.displayName || user.email || "";
    displayName = nameSource.split(" ")[0];
  }



  return (
    <div>
      <div className="background">
        <Container className="container-index"> 
          <NavbarIndex user={user} />
          
          <br />
          <div className="text-center container-sm index1">

              
              {user ? (
                <div className="logged-in">
                  <h1>{t("MAIN_WELCOME_TEXT", {"USER": displayName})}</h1>
                  <a className="btn btn-danger p-10 entry_button" role="button" href="/home" type="button">{t("MAIN_ENTRY_BUTTON")}</a>
                </div>
              ) : (
                <div className="logged-in">
                    <h1>{t("MAIN_TEXT1")}</h1>
                    <h3>{t("MAIN_TEXT2")}</h3>
                    <h3>{t("MAIN_TEXT3")}</h3>
                    <br />
                    <a className="btn btn-danger p-10 entry_button" role="button" href="/home" type="button">
                      {t("MAIN_EXPLORE_FREE_BUTTON") || "Explorar Libros Gratis"}
                    </a>
                </div>
              )}
          </div>
        </Container>
      </div>
      <div>
        <Container style={{backgroundColor: 'white'}}>
          <div> 
              <div className="separator"></div>

              <FaqAccordion />

              <div className="separator"></div>

              <Devices />


          </div>
        </Container>
        <Footer />
      </div>
    </div>
    
  );
}
